import { ConTextAtom } from '@gandalf/babylon/atoms/text';
import { ConLinkAtom } from '@gandalf/babylon/atoms/link';
import { getCustomerOrderDetailsUrl } from '@frodo/lib/utils/common/constants';
import { formatIsoDate } from '@frodo/lib/utils/common/stringUtils';
import { Translations } from '@frodo/models/types';
import { useStore } from '@frodo/lib/hooks/useStore';

type LastPurchasedProps = {
  lastPurchasedDate: string;
  lastOrderNumber: string;
  trans: Translations;
};

export const LastPurchased = ({
  lastPurchasedDate,
  lastOrderNumber,
  trans,
}: LastPurchasedProps) => {
  const store = useStore();

  return (
    <div>
      <ConTextAtom tag="span" fontSizes="small" fontWeight="bold">
        {trans['product.lastPurchased']}{' '}
      </ConTextAtom>
      <ConLinkAtom
        ariaLabel={trans['product.lastPurchased']}
        href={getCustomerOrderDetailsUrl(lastOrderNumber)}
        target="_blank"
      >
        <ConTextAtom
          tag="span"
          fontSizes="small"
          fontWeight="bold"
          color="text-blue-2"
        >
          {formatIsoDate(lastPurchasedDate ?? '', store)}
        </ConTextAtom>
      </ConLinkAtom>
    </div>
  );
};
